import { render, staticRenderFns } from "./GuestSelected.vue?vue&type=template&id=78a70f70"
import script from "./GuestSelected.vue?vue&type=script&lang=js"
export * from "./GuestSelected.vue?vue&type=script&lang=js"
import style0 from "./GuestSelected.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports